import { IonButton } from '@ionic/react';
import React from 'react';

interface HeaderButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  id?: string;
}

export const ToolbarButton: React.FC<HeaderButtonProps> = ({ children, onClick, id }) => {
  return (
    <IonButton
      id={id}
      onClick={onClick}
      size="small"
      color="dark"
      // Actually need to use "style" here,
      // otherwise it won't work.
      style={{
        '--padding-top': 0,
        '--padding-bottom': 0,
        '--padding-left': 0,
        '--padding-right': 0,
        '--padding-start': 0,
        '--padding-end': 0,
        width: 32,
        height: 32,
      }}
    >
      {children}
    </IonButton>
  );
};
